export enum MovieTypesEnum {
  COMING_SOON = 'COMING_SOON',
  SHOW_NOW = 'SHOWING_NOW',
}

export const BOOKMARK_NAME_MAX_LENGTH = 16;
